export enum SegmentType {
    Targeting = 'core',
    Retargeting = 'retargeting',
    Lookalike = 'lookalike'
}
